
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { common as enCommon } from './local/en/common';
import { common as frCommon } from './local/fr/common';

const resources = {
  en: {
    common: enCommon
  },
  fr: {
    common: frCommon
  }
};

i18n
  .use(initReactI18next)
  .init({
    lng: 'fr',
    fallbackLng: 'en',
    debug: false,
    resources,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
